module.exports = __webpack_public_path__ + "img/ic_recharge.0c0c931d.png";